import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface TipoResponsableIva {
  id: number;
  denominacion: string;
  codigoAfip: number;
}

export interface TipoResponsableIvas {
    tipoResponsableIvas: TipoResponsableIva[];
}

export interface ObtenerListadoTipoResponsableIva extends ResponseMessageWithInternalStatus{
  tiposResponsableIva: {
     id: number;
     denominacion: string;
     codigoAfip: number;
  }[]
}

export interface TipoResponsableIvasState {
  tipoResponsableIvas: TipoResponsableIva[];
  error: boolean;
  debugMessage?: any;
}

export const initialTipoResponsableIvasState: TipoResponsableIvasState = {
  tipoResponsableIvas: [],
  error: false,
  debugMessage: null
};